import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class SearchService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getUsers(params) {
    const result = await this.apiService.get('/users', params);
    return result;
  }

  async getConstructions(params) {
    const result = await this.apiService.get('/constructions', params);
    return result;
  }

  async getCustomers(params) {
    const result = await this.apiService.get('/customers_list', params);
    return result;
  }

  async getTeams(params) {
    const result = await this.apiService.get('/teams', params);
    return result;
  }

  async getOffices() {
    const result = await this.apiService.get('/offices');
    return result;
  }

  async getBranches() {
    const result = await this.apiService.get('/branches');
    return result;
  }

  async getResponsibleGroups() {
    const result = await this.apiService.get('/responsible_groups');
    return result;
  }

  async getObjectTypes(params) {
    const result = await this.apiService.get('/object_types', params);
    return result;
  }

  async getDistributionChannels() {
    const result = await this.apiService.get('/distribution_channels');
    return result;
  }

  async getSalesOrgs(params) {
    const result = await this.apiService.get('/sales_orgs', params);
    return result;
  }

  getMaterialGroups = async (params) => {
    const result = await this.apiService.get('/material_groups', params);

    return result.data.data.items;
  };

  async getMaterialGroupAliases(params) {
    const result = await this.apiService.get('/materials', params);

    return result;
  }

  getStages = async (params) => {
    const result = await this.apiService.get('/stages', params);

    return result.data.data.items;
  };

  async getStatuses(params) {
    const result = await this.apiService.get('/statuses', params);
    return result;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), SearchService, 0);

export default SearchService;
